export default __webpack_public_path__ + "static/media/icon-socials.4ee89408.svg";